<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
        <div class="row">
            <div class="col-md-8">
                <label class="report-label">{{ $t('data_exports.payments.date_range') }}</label>
                <base-select
                    v-model="selectedRange"
                    :options="dateRange"
                    :allow-empty="false"
                    :show-labels="false"
                    @input="onChangeDateRange"
                />
                <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
            </div>
        </div>
        <div class="row report-fields-container">
            <div class="col-md-6 report-field-container">
                <label class="report-label">{{ $t('data_exports.payments.from_date') }}</label>
                <base-date-picker
                    v-model="formData.from_date"
                    :invalid="$v.formData.from_date.$error"
                    :calendar-button="true"
                    calendar-button-icon="calendar"
                    @change="$v.formData.from_date.$touch()"
                    @input="setRangeToCustom"
                />
                <span v-if="$v.formData.from_date.$error && !$v.formData.from_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
            </div>
            <div class="col-md-6 report-field-container">
                <label class="report-label">{{ $t('data_exports.payments.to_date') }}</label>
                <base-date-picker
                    v-model="formData.to_date"
                    :invalid="$v.formData.to_date.$error"
                    :calendar-button="true"
                    calendar-button-icon="calendar"
                    @change="$v.formData.to_date.$touch()"
                    @input="setRangeToCustom"
                />
                <span v-if="$v.formData.to_date.$error && !$v.formData.to_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
            </div>
        </div>
        <div class="row report-fields-container">
           <div class="col-md-12 report-field-container">  
            <label  class="form-label">{{ $tc('data_exports.payments.user') }} </label>
            <base-select
              v-model="formData.company_id"
              :options="users"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_user')"
              group-values="options"
              group-label="label"
              track-by="id"
              label="name"
             
            />
           </div>
        </div>
        <div class="row report-submit-button-container">
            <div class="col-md-6">
            <base-button outline color="theme" class="report-button" @click="getReports()">
                {{ $t('data_exports.update_data') }}
            </base-button>
            </div>
        </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style"/>
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{ $t('data_exports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      dateRange: [
        'Today',
        'This Week',
        'This Month',
        'This Quarter',
        'This Year',
        'Previous Week',
        'Previous Month',
        'Previous Quarter',
        'Previous Year',
        'Custom'
      ],
      selectedRange: 'This Month',
      range: new Date(),
      formData: {
        from_date: moment().startOf('month').toString(),
        to_date: moment().endOf('month').toString(),
        company_id:null
      },
      url: null,
      customerSiteURL: null,
      newParentCustomersArray:[],
      newFunderArray:[],
      newCustomerArray:[],
      newClientArray:[],
      userType:null
    }
  },
  validations: {
    range: {
      required
    },
    formData: {
      from_date: {
        required
      },
      to_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    ...mapGetters('customer', [
      'customers',
      'parentCustomers',
      'simpleCustomers'
    ]),
    ...mapGetters('funder', [
      'funders',
    ]),
    ...mapGetters('supplier', [
      'suppliers',
    ]),
    getReportUrl () {
      return this.url
    },

    users:{
      get: function () {
        if(this.userType=='supplier'){
          return [
            {
              label: 'Buyer Customers',
              isDisable: true,
              options: this.newParentCustomersArray
            },
            {
              label: 'Funders',
              options: this.newFunderArray
            },
            {
              label: 'Super Admin',
              options: [
                {
                  id:1,
                  name:'Super Admin'
                }
              ]
            },
          ];
        }else if(this.userType=='funder'){
          return [
            {
              label: 'Clients',
              isDisable: true,
              options: this.newClientArray
            },
            {
              label: 'Super Admin',
              options: [
                {
                  id:1,
                  name:'Super Admin'
                }
              ]
            },
          ];
        }else if(this.userType=='anchor'){
          return [
            {
              label: 'Suppliers',
              isDisable: true,
              options: this.newCustomerArray
            }
          ];
        }
      },
      set: function (val) {
        this.formData.company_id= val
      }
    },
  },
  watch: {
    range (newRange) {
      this.formData.from_date = moment(newRange).startOf('year').toString()
      this.formData.to_date = moment(newRange).endOf('year').toString()
    }
  },
  created(){
    let data={ pagination:'no'}

    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor'
      this.getSuppliers()
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder'
      this.getClients()
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';   
      this.fetchSimpleCustomers()
      this.getBuyerCustomers()
      this.getFunders()   
    }
    
  },
  mounted () {
    this.customerSiteURL = `/data-exports/payments/user/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },
  methods: {
    ...mapActions('customer', [
      'fetchCustomers',
      'fetchSimpleCustomers',
      'fetchParentCustomers'
    ]),
    ...mapActions('funder', [
      'fetchFunders',
    ]),
    ...mapActions('supplier', [
      'fetchSuppliers',
    ]),

    async getClients(){
      let res= await this.fetchCustomers({pagination:'no'})
      let customerArray = res.data.customers.data
      this.newClientArray = customerArray.map(function(row) {
        return { id : row.company_id, name : row.company_name}
      })
    },
    async getSuppliers(){
      let res= await this.fetchSuppliers({pagination:'no', role:'admin'})
      let customerArray = res.data.suppliers.data
      this.newCustomerArray = customerArray.map(function(row) {
        return { id : row.company_id, name : row.company_name}
      })
    },
    async getFunders(){
      let res= await this.fetchFunders({pagination:'no'})
      let funderArray = res.data.funders.data
      this.newFunderArray = funderArray.map(function(row) {
        return { id : row.company_id, name : row.company_name}
      })
    },
    async getBuyerCustomers(){
      let res= await this.fetchParentCustomers()
      let parentCustomersArray = res.data.customers
      this.newParentCustomersArray = parentCustomersArray.map(function(row) {
        return { id : row.parent_account.company.id, name : row.name, customer_id:row.id }
      })
    },
    getThisDate (type, time) {
      return moment()[type](time).toString()
    },
    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },
    onChangeDateRange () {
      switch (this.selectedRange) {
        case 'Today':
          this.formData.from_date = moment().toString()
          this.formData.to_date = moment().toString()
          break

        case 'This Week':
          this.formData.from_date = this.getThisDate('startOf', 'isoWeek')
          this.formData.to_date = this.getThisDate('endOf', 'isoWeek')
          break

        case 'This Month':
          this.formData.from_date = this.getThisDate('startOf', 'month')
          this.formData.to_date = this.getThisDate('endOf', 'month')
          break

        case 'This Quarter':
          this.formData.from_date = this.getThisDate('startOf', 'quarter')
          this.formData.to_date = this.getThisDate('endOf', 'quarter')
          break

        case 'This Year':
          this.formData.from_date = this.getThisDate('startOf', 'year')
          this.formData.to_date = this.getThisDate('endOf', 'year')
          break

        case 'Previous Week':
          this.formData.from_date = this.getPreDate('startOf', 'isoWeek')
          this.formData.to_date = this.getPreDate('endOf', 'isoWeek')
          break

        case 'Previous Month':
          this.formData.from_date = this.getPreDate('startOf', 'month')
          this.formData.to_date = this.getPreDate('endOf', 'month')
          break

        case 'Previous Quarter':
          this.formData.from_date = this.getPreDate('startOf', 'quarter')
          this.formData.to_date = this.getPreDate('endOf', 'quarter')
          break

        case 'Previous Year':
          this.formData.from_date = this.getPreDate('startOf', 'year')
          this.formData.to_date = this.getPreDate('endOf', 'year')
          break

        default:
          break
      }
    },
    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },
    async getInitialReport () {
      if (this.selectedType === 'By Customer') {
        this.url = `${this.customerSiteURL}?from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        return true
      }
      return true
    },
    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },
    async getReports (isDownload = false) {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      if (this.selectedType === 'By Customer') {
        if(this.formData.company_id && this.formData.company_id !=null){
            this.url = `${this.customerSiteURL}?company_id=${this.formData.company_id.id}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        }else{
            this.url = `${this.customerSiteURL}?from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        }
        return true
      }

      return true
    },
    downloadReport () {
      if (!this.getReports()) {
        return false
      }

      window.open(this.getReportUrl + '&download=true')
      setTimeout(() => {
        if (this.selectedType === 'By Customer') {
            if(this.formData.company_id && this.formData.company_id != null){
                this.url = `${this.customerSiteURL}?company_id=${this.formData.company_id.id}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
            }else{
                this.url = `${this.customerSiteURL}?from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
            }
            return true
        }
        return true
      }, 200)
    },
  }
}
</script>